<template>
  <div class="page flex-col">
    <video autoplay muted loop>
      <source src="./assets/img/login.mp4" type="video/mp4">
    </video>
    <div class="group_1 flex-row justify-end scaler">
      <div class="group_2 flex-col">
        <div class="group_3 flex-row align-center">
          <div class="section_1 flex-col"></div>
          <div class="text-wrapper_1 flex-col">
            <span class="text_1" style="margin-left: 20px;">{{ dynamicTitle }}</span>
            <!-- <span class="text_2">{{ dynamicText }}</span> -->
          </div>
        </div>
        <div class="text-wrapper_1 flex-col">
          <span class="text_1">欢迎使用AI多面体人才库</span>
          <span class="text_2">智能招聘，高效匹配人才</span>
        </div>
        <router-view @update-text="handleTextUpdate"></router-view>
      </div>
      <div class="group_12 flex-col">
        <div class="group_13 flex-col">
          <div class="text-wrapper_7 flex-row"><span class="text_13">AI人才库</span></div>
          <div class="text-wrapper_8 flex-row">
            <span class="paragraph_1">
              提升求职效率
              <br />
              优化招聘流程
              <br />
              发掘顶尖人才
            </span>
          </div>
          <a href="https://beian.miit.gov.cn/" target="_blank" style="position:absolute;bottom:15px;right:185px;font-size:large;">粤ICP备2025376732号-1</a>
          <div class="text-wrapper_9 flex-row"><span class="text_14">屿智同行</span></div>
        </div>
      </div>
      <div class="image-wrapper_1 flex-col">
        <img class="image_2" referrerpolicy="no-referrer"
          src="./assets/img/avatar.png" />
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      activeTab: 'login',
      phone: '',
      password: '',
      agree: false,
      selectedFile: null,
      dynamicText: '欢迎使用多面体人才库',
      dynamicTitle: 'AI多面体人才库'
    };
  },
  provide() {
    return {
      updateText: this.updateText,
      updateTitle: this.updateTitle
    };
  },
  mounted() {
    // 监听路由变化，动态更新文本
    this.updateTextByRoute();
    this.$router.afterEach(() => {
      this.updateTextByRoute();
    });
  },
  methods: {
    updateTextByRoute() {
      const route = this.$route.path;
      switch(route) {
        case '/entry/verifyCompany':
          this.dynamicTitle = '企业认证';
          this.dynamicText = '请验证您所属的公司';
          break;
        case '/entry/loginEmail':
          this.dynamicTitle = '邮箱登录';
          this.dynamicText = '请输入您的邮箱';
          break;
        case '/entry/loginPwd':
          this.dynamicTitle = '密码登录';
          this.dynamicText = '请输入您的密码';
          break;
        case '/entry/loginQRCode':
          this.dynamicTitle = '扫码登录';
          this.dynamicText = '请扫描二维码登录';
          break;
        default:
          this.dynamicTitle = 'AI多面体人才库';
          this.dynamicText = '欢迎使用AI多面体人才库';
      }
    },
    
    // 处理子组件传递的文本更新事件
    handleTextUpdate(text) {
      this.dynamicText = text;
    },
    
    // 提供给子组件调用的方法
    updateText(text) {
      this.dynamicText = text;    },
    
    // 提供给子组件调用的标题更新方法
    updateTitle(title) {
      this.dynamicTitle = title;
    }
  }
};
</script>
<style scoped lang="css" src="./assets/index.css" />
<style scoped>
/* .scaler {
  transform-origin: top left;
  transform: scale(0.67);
} */

@media (max-width: 1600px) {
  .scaler {
    transform-origin: center;
    transform: scale(0.67);
  }
}

@media (min-width: 1600px) {
  .scaler {
    transform-origin: center;
    transform: scale(0.8);
  }
}

</style>